__turbopack_context__.v({
  "body": "EditOfficeHoursForm-module-scss-module__7dbT_W__body",
  "center": "EditOfficeHoursForm-module-scss-module__7dbT_W__center",
  "row": "EditOfficeHoursForm-module-scss-module__7dbT_W__row",
  "separator": "EditOfficeHoursForm-module-scss-module__7dbT_W__separator",
});
